import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const UploadBackgroundLabel = (formData: FormData): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.BackgroundLabelCommandURL.UploadBackgroundLabel,
        method: RequestType.POST,
        data: formData,
        skipContentType: true,
    });

const DeleteBackgroundLabel = (params: { s3Key: string; id?: number }): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.BackgroundLabelCommandURL.DeleteBackgroundLabel,
        method: RequestType.DELETE,
        params,
    });

const UpdateBackgroundLabelDisplayOrder = (data: {
    category: string;
    type: number;
    ids: number[];
}): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.BackgroundLabelCommandURL.UpdateBackgroundLabelDisplayOrder,
        method: RequestType.PUT,
        data,
    });

export const BackgroundLabelCommand = {
    UploadBackgroundLabel,
    DeleteBackgroundLabel,
    UpdateBackgroundLabelDisplayOrder,
};

